import { Component, OnInit } from "@angular/core";

import { Subject } from "rxjs";

import { DffRouteParams } from "@dffedb/router";
import { UnsubscribeOnDestroy } from "@dffedb/util";
import { Installation, VaelgInstallationService } from "@e-forsyning/common/installation";
import { RedirectService } from "@e-forsyning/common/router";

import { DeeplinkSandbox } from "../services/deeplink.sandbox";

@Component({
    templateUrl: "./deeplink-side.component.html"
})
export class DeeplinkSideComponent extends UnsubscribeOnDestroy implements OnInit {
    private side: string;
    public installationer$ = new Subject<Installation[]>();

    constructor(
        private readonly routeParams: DffRouteParams,
        private readonly vaelgInstallationService: VaelgInstallationService,
        private readonly redirectService: RedirectService,
        private readonly sandbox: DeeplinkSandbox
    ) {
        super();
    }

    public async ngOnInit(): Promise<void> {
        try {
            if (!(await this.sandbox.loginMedGemteCredentials())) {
                this.sandbox.redirectTilLogin();
                return;
            }

            this.side = this.routeParams.get("side");
            const ejendomNr = +this.routeParams.get("ejendomnr");
            const installationNr = +this.routeParams.get("installationnr");
            const installationer = await this.sandbox.findInstallationerForEjendom(ejendomNr);
            const installation = this.sandbox.findInstallation(installationer, installationNr);
            if (installation) {
                this.sandbox.vaelgInstallation(installation);
                this.sandbox.redirectTilSide(this.side);
            } else {
                this.installationer$.next(installationer);
            }
        } catch (error) {
            this.installationer$.error(error);
        }
    }

    public onVaelgInstallation(installation: Installation): void {
        this.sandbox.vaelgInstallation(installation);
        this.sandbox.redirectTilSide(this.side);
    }

    public onSeAlleInstallationer(): void {
        this.sandbox.redirectTilInstallationer();
    }
}
